import React, { useContext } from 'react'
import { AppContext } from '../../../App'
import QuoteActionLinks from '../../QuoteActionLinks'
import QuoteModals from '../../QuoteModals'

export default function GroutQuoteCreated() {
    const { coverageDetails, coverageData, productOptionsSelected, unit } = useContext(AppContext)
    const { coverage, tileThicknessText, jointSizeText } = coverageData
    const { totalArea, tileWidth, tileHeight } = coverageDetails.formData
    const productType = productOptionsSelected.productOptions[1]
    const m2 = <span>&#13217;</span>
    const mmOrInches = unit === "sqft" ? "\"" : unit
   return (
      <React.Fragment>
         <div className="col-xs-12">
            <h3>Coverage Details</h3>
            <div className="data-table">
               <div className="row hidden-xs">
                  <div className="col-xs-12 col-sm-3">Total Area</div>
                  <div className="col-xs-12 col-sm-3">Tile Size (WxH)</div>
                  <div className="col-xs-12 col-sm-3">Tile Thickness</div>
                  <div className="col-xs-12 col-sm-3">Joint Size</div>
               </div>
               <div className="row p-1">
                  <div className="col-xs-12">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Total Area: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-3">
                                   {totalArea} {unit === "mm" ? m2 : unit}
                        </div>
                        <div className="col-xs-6 visible-xs">
                           <strong>Tile Width: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-3">
                                   {tileWidth}{mmOrInches}x{tileHeight}{mmOrInches}
                        </div>
                        <div className="col-xs-6 visible-xs">
                           <strong>Tile Thickness: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-3">
                           { tileThicknessText }
                        </div>
                        <div className="col-xs-6 visible-xs">
                           <strong>Joint Size: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-3">
                           { jointSizeText }
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <h3>Supplies</h3>
            <div className="data-table">
               <div className="row hidden-xs">
                  <div className="col-xs-12 col-sm-4">Coverage</div>
                  <div className="col-xs-12 col-sm-4">Required Amount</div>
                  <div className="col-xs-12 col-sm-4">Quantity</div>
               </div>
               <div className="row p-1">
                  <div className="col-xs-12 col-sm-4">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Coverage: </strong>
                        </div>
                               <div className="col-xs-6 col-sm-12">
                                   {coverage + " "} {unit === "mm" ? m2 : unit} per unit
                                   
                        </div>
                     </div>
                  </div>
                  <div className="col-xs-12 col-sm-4">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Required Amount: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                                   { coverageData.unitsRequiredDefault } units
                        </div>
                     </div>
                  </div>
                  <div className="col-xs-12 col-sm-4">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                                   <strong>Suggested Quantity: </strong>
                        </div>
                               <div className="col-xs-6 col-sm-12">
                                   {coverageData.actualUnitsRequiredDefault}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row p-1">
               <QuoteActionLinks productType={ productType } />
            </div>
            <QuoteModals />
         </div>
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/grout/GroutQuoteCreated.js